import { Reveal } from "@/components/Reveal";
import { PageHeader } from "@/pages/Services";
import { useSettings } from "@/context/SettingsContext";
import { Target, Eye, Award } from "lucide-react";

export default function About() {
  const s = useSettings();
  return (
    <div>
      <PageHeader eyebrow="Tentang Kami" title="Inovasi Teknologi untuk Masa Depan" subtitle={s.tagline} />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16 sm:py-24 grid lg:grid-cols-2 gap-12 items-center">
        <Reveal>
          <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" alt="Tim" className="rounded-3xl gold-border w-full h-80 object-cover live-img" />
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-syne font-bold text-2xl sm:text-3xl text-white mb-4">Siapa Kami</h2>
          <p className="text-white/70 leading-relaxed">{s.about || "PT Lotus Lentera hadir sebagai mitra teknologi terpercaya untuk membantu bisnis, instansi, dan pemerintah dalam mewujudkan transformasi digital yang efektif, aman dan berkelanjutan."}</p>
        </Reveal>
      </section>
      <section className="bg-[#0F1117] border-y border-amber-500/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16 sm:py-24 grid md:grid-cols-3 gap-6">
          {[
            { icon: Target, title: "Misi", desc: "Menyediakan solusi teknologi terintegrasi yang aman, andal, dan berdampak nyata bagi klien." },
            { icon: Eye, title: "Visi", desc: "Menjadi mitra transformasi digital terdepan di Indonesia." },
            { icon: Award, title: "Nilai", desc: "Integritas, inovasi, dan fokus pada kepuasan pelanggan." },
          ].map((v, i) => (
            <Reveal key={v.title} delay={i * 0.08}>
              <div className="bg-ll-card rounded-2xl p-7 gold-border h-full">
                <div className="w-12 h-12 rounded-xl btn-gold flex items-center justify-center mb-4"><v.icon className="w-6 h-6" /></div>
                <h3 className="font-syne font-semibold text-lg text-white">{v.title}</h3>
                <p className="text-sm text-white/60 mt-2">{v.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
